export enum FeatureIdentifier {
	DEFAULT = 'DEFAULT', // Usado para plano ou módulo q não tem funcionalidade (ex: plano personalizado)
	MENU = 'MENU',
	LOCAL_ORDER = 'LOCAL_ORDER',
	DELIVERY_ORDER = 'DELIVERY_ORDER',
	FULL_ORDER = 'FULL_ORDER',
	BOOKING_TABLE = 'BOOKING_TABLE',
	MULTI_LANG = 'MULTI_LANG',
	QUEUE = 'QUEUE'
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/feature-identifier.enum.ts